module.exports = __webpack_public_path__ + "static/img/manual-5.b7828ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-5.png
// module id = LFKE
// module chunks = 4